export const getIAMarksSub = (state = [], action) => {
  switch (action.type) {
    case "GET_UPDT_IA_SUB_DATA":
      return action.payload.data;
    default:
      return state;
  }
};
